import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SelectItem } from "primeng/primeng";
import { CatalogService } from "src/app/_services/api_v1/catalogs.service";
import { FormsService } from "src/app/_services/api_v1/forms.service";
import { Properties } from "../general/properties";

import { BreadcrumbService } from "src/app/breadcrumb.service";

import { PersonFormModel } from "src/app/_model/documents/models";

//Encriptar
import { CriptoService } from "src/app/_handler/cripto.service";
import { InitCompany } from "src/app/_model/documents/initCompany";
import { InitContratantePersona } from "src/app/_model/documents/initContratantePerson";
import { InitFormModel } from "src/app/_model/documents/initForm";
import { InitPersonFormModel } from "src/app/_model/documents/initPersonForm";

type DataProcessingStatus = 'IDLE' | 'LOADING' | 'ACCEPTED' | 'PENDING' | 'ERROR';
type DeceasedCustomerType = 'INSURED' | 'CONTRACTOR';

interface NaturalPersonLookup {
    documentNumber: string;
    encryptedDocument: string;
}

interface DataProcessingAcceptanceRequest {
    documentNumber: string;
    documentType: string;
    ramo: string;
    rucBroker: string;
    email: string;
}

interface DataProcessingCustomerRequest {
    documentNumber: string;
    documentType: string;
    ramo: string;
    rucBroker: string;
}

@Component({
    selector: "solicitudes",
    templateUrl: "./solicitudes.html",
    styleUrls: ["./solicitudes.css"],
})
export class SolicitudesComponent implements OnInit {
    properties: Properties = new Properties();
    es: any = this.properties.es;
    titulo: string;
    subtitulo: string;
    tituloformulario: string;
    tituloResultado: string;
    tituloContratante: string;
    tituloResultadoContratante: string;

    // Banderas
    bandera: number = 0;
    botonEnviar: any = 0;
    mostrarContratante: boolean = false;

    // Data protection
    dataProtectionAccepted = false;
    dataProtectionModalOpen = false;
    dataProcessingStatus: DataProcessingStatus = 'IDLE';
    dataProcessingError = '';
    customerLookupError = '';
    customerLookupInProgress = false;
    private dataProcessingLookupKey = '';
    private encryptedLookupDocument = '';
    private dataProcessingRequestId = 0;
    private customerLookupRequestId = 0;
    private readonly dataProcessingBranch = 'FORM';
    contractorDataProtectionAccepted = false;
    contractorDataProcessingStatus: DataProcessingStatus = 'IDLE';
    contractorDataProcessingError = '';
    contractorCustomerLookupError = '';
    contractorLookupInProgress = false;
    private contractorDataProcessingLookupKey = '';
    private encryptedContractorLookupDocument = '';
    private contractorDataProcessingRequestId = 0;
    private contractorLookupRequestId = 0;
    deceasedCustomerModalOpen = false;
    private deceasedCustomerType: DeceasedCustomerType;

    openDataProtectionModal(): void {
        this.dataProtectionModalOpen = true;
    }

    acceptDataProtection(): void {
        this.dataProtectionAccepted = true;
    }

    closeDeceasedCustomerModal(): void {
        this.deceasedCustomerModalOpen = false;

        if (this.deceasedCustomerType === 'CONTRACTOR') {
            this.clearContractorSearch();
        } else {
            this.clearInsuredSearch();
        }
    }

    // Catalogos
    tipoDocumentoSelectItem: SelectItem[] = [
        { label: this.properties.labelSelecioneCombo, value: null },
    ];
    generos: SelectItem[] = [];
    respuestas: SelectItem[] = [];
    personTypeList: SelectItem[] = [];
    tipoEstadoCivilSelectItem: SelectItem[] = [
        { label: this.properties.labelSelecioneCombo, value: null },
    ];
    tipoPersona = "N";
    tipoPersonaC = "N";

    // Modelos
    // Asegurado
    formulario: InitFormModel;
    nuevoFormulario: any;
    person = new InitPersonFormModel();
    company = new InitCompany();

    // Contratante
    figura: InitContratantePersona;
    personC = new PersonFormModel();
    aseguradoC: any = null;
    companyC = new InitCompany();
    validDocAseg: boolean;
    validDocCont: boolean;
    tipoDocumento: any;
    found: boolean;
    initialInsuredBirthFound: boolean;
    naturalNotFound: boolean;
    numeroDocumento: any;
    primerNombre: any;
    segundoNombre: any;
    primerApellido: any;
    segundoApellido: any;
    genero: any = null;
    estadoCivil: any;
    fechaNacimiento: any;
    email: any;
    numeroCelular: any;
    // Contratante
    tipoDocumentoC: any;
    numeroDocumentoC: any;
    primerNombreC: any;
    segundoNombreC: any;
    primerApellidoC: any;
    segundoApellidoC: any;
    foundContract: boolean;
    initialContractBirthFound: boolean;
    generoC: any;
    estadoCivilC: any;
    fechaNacimientoC: any;
    emailC: any;
    numeroCelularC: any;

    // Compañía
    razonSocial: any;
    fechaConstitucion: Date = new Date();
    emailCompania: any;
    numeroCelularCompania: any;
    haveContracting: boolean = true;

    // Seguridad
    tipoDocumentoEncriptado: any;
    numeroDocumentoEncriptado: any;

    // Broker
    user: any;

    minDate: Date;
    maxAgeDate: Date;

    constructor(
        private catalogService: CatalogService,
        private formService: FormsService,
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        private criptoService: CriptoService
    ) {
        this.minDate = new Date(1910, 0, 1);
        const hoy = new Date();
        this.maxAgeDate = new Date(
            hoy.getFullYear() - 18,
            hoy.getMonth(),
            hoy.getDate()
        );
    }

    get yearRangeMaxAge(): string {
        return `${this.minDate.getFullYear()}:${this.maxAgeDate.getFullYear()}`;
    }

    get yearCurrentRange(): string {
        return `${this.minDate.getFullYear()}:${new Date().getFullYear()}`;
    }

    ngOnInit(): void {
        this.cargarBreadCrum();
        const currentUser = JSON.parse(sessionStorage.getItem("access_token"));
        this.user = currentUser.user;
        // console.log("Este es el usuario  autenticado", this.user);
        this.cargarBreadCrum();
        this.titulo = "Solicitar formulario de conocimiento de cliente";
        this.subtitulo =
            "Ingresa la siguiente información para enviar el formulario a tu cliente";
        this.tituloformulario = "Información del asegurado";
        this.tituloContratante = "Información del contratante";
        this.tituloResultado =
            "Encontramos datos asociados, revisa la siguiente información";
        this.tituloResultadoContratante =
            "Encontramos datos asociados, revisa la siguiente información";
        this.generos = this.properties.generos;
        this.respuestas = this.properties.respuestas;
        this.personTypeList = this.properties.tipoPersona;
        this.cargarTipoDocumento();
        this.cargarTipoEstadoCivil();
        this.validDocAseg = true;
        this.validDocCont = true;
    }

    validDocument(type) {
        let validDoc;
        let documentN;
        if (type == 'Aseg') {
            documentN = this.numeroDocumento || '';
        } else {
            documentN = this.numeroDocumentoC || '';
        }

        validDoc = true;
        if (documentN.length == 13) {
            const lastD = documentN.substr(documentN.length - 3);
            if (['001', '002', '003'].includes(lastD)) {
                validDoc = true;
            } else {
                validDoc = false;
            }
        }
        this[`validDoc${type}`] = validDoc;
    }

    onInsuredDocumentChange(): void {
        this.validDocument('Aseg');
        this.checkDataProcessingStatus();
    }

    onInsuredDocumentBlur(): void {
        this.validDocument('Aseg');
        this.checkDataProcessingStatus();
    }

    onInsuredPersonTypeChange(): void {
        this.changePersonType();
        this.resetDataProcessingState();
        this.checkDataProcessingStatus();
    }

    onContractorDocumentChange(): void {
        this.validDocument('Cont');
        this.checkContractorDataProcessingStatus();
    }

    onContractorDocumentBlur(): void {
        this.validDocument('Cont');
        this.checkContractorDataProcessingStatus();
    }

    onContractorPersonTypeChange(): void {
        this.resetContractorDataProcessingState();
        this.checkContractorDataProcessingStatus();
    }

    canSearchInsured(): boolean {
        if (this.customerLookupInProgress) {
            return false;
        }

        if (!this.requiresDataProcessing()) {
            return true;
        }

        return this.dataProcessingStatus === 'ACCEPTED' ||
            (this.dataProcessingStatus === 'PENDING' && this.dataProtectionAccepted);
    }

    shouldShowDataProtectionConsent(): boolean {
        return this.requiresDataProcessing() && this.dataProcessingStatus === 'PENDING';
    }

    canSearchContractor(): boolean {
        if (this.contractorLookupInProgress) {
            return false;
        }

        if (!this.requiresContractorDataProcessing()) {
            return true;
        }

        return this.contractorDataProcessingStatus === 'ACCEPTED' ||
            (this.contractorDataProcessingStatus === 'PENDING' && this.contractorDataProtectionAccepted);
    }

    shouldShowContractorDataProtectionConsent(): boolean {
        return this.requiresContractorDataProcessing() && this.contractorDataProcessingStatus === 'PENDING';
    }

    private checkDataProcessingStatus(): void {
        const lookup = this.getNaturalPersonLookup();
        const lookupKey = lookup ? this.getDataProcessingLookupKey(lookup.documentNumber) : '';

        if (lookupKey === this.dataProcessingLookupKey) {
            return;
        }

        this.resetDataProcessingState();
        if (!lookup) {
            return;
        }

        this.dataProcessingLookupKey = lookupKey;
        this.encryptedLookupDocument = lookup.encryptedDocument;
        this.dataProcessingStatus = 'LOADING';
        const requestId = ++this.dataProcessingRequestId;

        this.formService.getDataProcessingAcceptance(
            this.getDataProcessingStatusDocumentType(this.tipoDocumento),
            lookup.encryptedDocument,
            this.user.brokerId,
            this.dataProcessingBranch
        ).subscribe(
            (response: any) => this.handleDataProcessingStatusResponse(response, requestId, lookupKey),
            () => this.handleDataProcessingStatusError(requestId, lookupKey)
        );
    }

    private handleDataProcessingStatusResponse(response: any, requestId: number, lookupKey: string): void {
        if (!this.isCurrentDataProcessingRequest(requestId, lookupKey)) {
            return;
        }

        const status = String(response && response.status || '').toUpperCase();
        if (status === 'ACEPTADO') {
            this.dataProcessingStatus = 'ACCEPTED';
            return;
        }

        if (status === 'PENDIENTE') {
            this.dataProcessingStatus = 'PENDING';
            return;
        }

        this.dataProcessingStatus = 'ERROR';
        this.dataProcessingError = 'No fue posible validar la autorización de uso de datos.';
    }

    private handleDataProcessingStatusError(requestId: number, lookupKey: string): void {
        if (!this.isCurrentDataProcessingRequest(requestId, lookupKey)) {
            return;
        }

        this.dataProcessingStatus = 'ERROR';
        this.dataProcessingError = 'No fue posible validar la autorización de uso de datos.';
    }

    private isCurrentDataProcessingRequest(requestId: number, lookupKey: string): boolean {
        return requestId === this.dataProcessingRequestId && lookupKey === this.dataProcessingLookupKey;
    }

    private getNaturalPersonLookup(): NaturalPersonLookup {
        return this.getNaturalPersonLookupFor(this.tipoDocumento, this.tipoPersona, this.numeroDocumento);
    }

    private requiresDataProcessing(): boolean {
        return this.requiresDataProcessingFor(this.tipoDocumento, this.tipoPersona);
    }

    private getNaturalPersonLookupFor(documentType: any, personType: string, document: any): NaturalPersonLookup | null {
        if (!this.requiresDataProcessingFor(documentType, personType)) {
            return null;
        }

        const documentNumber = String(document || '').trim();
        const lookupDocument = documentType.id === 2 ? documentNumber.substring(0, 10) : documentNumber;
        if (documentType.id === 1 && lookupDocument.length !== 10) {
            return null;
        }
        if (documentType.id === 2 && (documentNumber.length < 10 || lookupDocument.length !== 10)) {
            return null;
        }
        if (documentType.id === 3 && lookupDocument.length < 3) {
            return null;
        }

        return { documentNumber: lookupDocument, encryptedDocument: this.criptoService.set(lookupDocument) };
    }

    private requiresDataProcessingFor(documentType: any, personType: string): boolean {
        if (!documentType) {
            return false;
        }

        return documentType.id === 1 || documentType.id === 3 || (documentType.id === 2 && personType === 'N');
    }

    private requiresCustomerLookup(): boolean {
        return this.requiresCustomerLookupFor(this.tipoDocumento, this.tipoPersona);
    }

    private requiresCustomerLookupFor(documentType: any, personType: string): boolean {
        return documentType && (documentType.id === 1 || (documentType.id === 2 && personType === 'N'));
    }

    private requiresContractorDataProcessing(): boolean {
        return this.requiresDataProcessingFor(this.tipoDocumentoC, this.tipoPersonaC);
    }

    private getDataProcessingStatusDocumentType(documentType: any): number | string {
        return documentType && documentType.id === 3 ? 'P' : 1;
    }

    private getDataProcessingAcceptanceDocumentType(documentType: any): string {
        return documentType && documentType.id === 3 ? 'P' : 'C';
    }

    private requiresContractorCustomerLookup(): boolean {
        return this.requiresCustomerLookupFor(this.tipoDocumentoC, this.tipoPersonaC);
    }

    private getContractorNaturalPersonLookup(): NaturalPersonLookup {
        return this.getNaturalPersonLookupFor(this.tipoDocumentoC, this.tipoPersonaC, this.numeroDocumentoC);
    }

    private getDataProcessingLookupKey(documentNumber: string): string {
        return `${this.tipoDocumento.id}-${documentNumber}-${this.user.brokerId}-${this.dataProcessingBranch}`;
    }

    private getContractorDataProcessingLookupKey(documentNumber: string): string {
        return `${this.tipoDocumentoC.id}-${documentNumber}-${this.user.brokerId}-${this.dataProcessingBranch}`;
    }

    private resetDataProcessingState(): void {
        this.dataProcessingRequestId++;
        this.dataProcessingLookupKey = '';
        this.encryptedLookupDocument = '';
        this.dataProcessingStatus = 'IDLE';
        this.dataProcessingError = '';
        this.customerLookupError = '';
        this.customerLookupInProgress = false;
        this.naturalNotFound = false;
        this.customerLookupRequestId++;
        this.dataProtectionAccepted = false;
        this.dataProtectionModalOpen = false;
    }

    private checkContractorDataProcessingStatus(): void {
        const lookup = this.getContractorNaturalPersonLookup();
        const lookupKey = lookup ? this.getContractorDataProcessingLookupKey(lookup.documentNumber) : '';
        if (lookupKey === this.contractorDataProcessingLookupKey) {
            return;
        }

        this.resetContractorDataProcessingState();
        if (!lookup) {
            return;
        }

        this.contractorDataProcessingLookupKey = lookupKey;
        this.encryptedContractorLookupDocument = lookup.encryptedDocument;
        this.contractorDataProcessingStatus = 'LOADING';
        const requestId = ++this.contractorDataProcessingRequestId;
        this.formService.getDataProcessingAcceptance(
            this.getDataProcessingStatusDocumentType(this.tipoDocumentoC),
            lookup.encryptedDocument,
            this.user.brokerId,
            this.dataProcessingBranch
        )
            .subscribe(
                (response: any) => this.handleContractorDataProcessingStatusResponse(response, requestId, lookupKey),
                () => this.handleContractorDataProcessingStatusError(requestId, lookupKey)
            );
    }

    private handleContractorDataProcessingStatusResponse(response: any, requestId: number, lookupKey: string): void {
        if (!this.isCurrentContractorDataProcessingRequest(requestId, lookupKey)) {
            return;
        }

        const status = String(response && response.status || '').toUpperCase();
        if (status === 'ACEPTADO' || status === 'PENDIENTE') {
            this.contractorDataProcessingStatus = status === 'ACEPTADO' ? 'ACCEPTED' : 'PENDING';
            return;
        }

        this.contractorDataProcessingStatus = 'ERROR';
        this.contractorDataProcessingError = 'No fue posible validar la autorización de uso de datos.';
    }

    private handleContractorDataProcessingStatusError(requestId: number, lookupKey: string): void {
        if (!this.isCurrentContractorDataProcessingRequest(requestId, lookupKey)) {
            return;
        }

        this.contractorDataProcessingStatus = 'ERROR';
        this.contractorDataProcessingError = 'No fue posible validar la autorización de uso de datos.';
    }

    private isCurrentContractorDataProcessingRequest(requestId: number, lookupKey: string): boolean {
        return requestId === this.contractorDataProcessingRequestId && lookupKey === this.contractorDataProcessingLookupKey;
    }

    private resetContractorDataProcessingState(): void {
        this.contractorDataProcessingRequestId++;
        this.contractorLookupRequestId++;
        this.contractorDataProcessingLookupKey = '';
        this.encryptedContractorLookupDocument = '';
        this.contractorDataProcessingStatus = 'IDLE';
        this.contractorDataProcessingError = '';
        this.contractorCustomerLookupError = '';
        this.contractorDataProtectionAccepted = false;
        this.contractorLookupInProgress = false;
    }

    cargarBreadCrum() {
        this.breadcrumbService.setItems([
            { label: "Inicio", routerLink: ["/home"] },
            { label: "Gestión de solicitudes" },
            {
                label: "Crear solicitud de vinculación",
                routerLink: ["/solicitudes"],
            },
        ]);
    }

    cargarTipoDocumento() {
        this.catalogService.getCatalogs("documentType", "EC").subscribe(
            (catalogos: any) => {
                catalogos.forEach((element) => {
                    this.tipoDocumentoSelectItem.push({
                        label: element.description,
                        value: element,
                    });
                });
            },
            (err: any) => console.log(err),
            () => { }
        );
    }

    cargarTipoEstadoCivil() {
        this.catalogService
            .getCatalogs(this.properties.civilStatus, "EC")
            .subscribe(
                (resp: any) => {
                    this.tipoEstadoCivilSelectItem = [];
                    this.tipoEstadoCivilSelectItem.push({
                        label: this.properties.labelSelecioneCombo,
                        value: null,
                    });
                    resp.forEach((element) => {
                        delete element.code;
                        const catalog = {
                            label: element.description,
                            value: element,
                        };
                        this.tipoEstadoCivilSelectItem.push(catalog);
                    });
                },
                (err: any) => console.log(err),
                () => { }
            );
    }

    changeContDocType() {
        this.resetContractorDataProcessingState();
        this.botonEnviar = 1;
        this.naturalNotFound = false;
        this.figura = null;
        this.mostrarContratante = false;
        this.aseguradoC = null;
        this.personC = new PersonFormModel();
        this.companyC = new InitCompany();
        this.numeroDocumentoC = null;
        this.tipoPersonaC = "N";
    }

    changeAsegDocType() {
        this.resetDataProcessingState();
        this.naturalNotFound = false;
        this.bandera = 0;
        this.botonEnviar = 0;
        this.mostrarContratante = false;
        this.figura = null;
        this.haveContracting = true;
        this.personC = new PersonFormModel();
        this.aseguradoC = null;
        this.companyC = new InitCompany();
        this.formulario = new InitFormModel();
        this.nuevoFormulario = null;
        this.person = new PersonFormModel();
        this.company = new InitCompany();
        this.tipoDocumentoC = null;
        this.numeroDocumentoC = null;
        this.numeroDocumento = '';
        this.tipoPersona = "N";
        this.tipoPersonaC = "N";
    }

    soloNumeros(event, verify) {
        if (verify) {
            var valido =
                event.charCode == 0 ||
                (event.charCode >= 48 && event.charCode <= 57);
            if (!valido) {
                event.preventDefault();
            }
        }
    }

    buscarAsegurado() {
        if (!this.canSearchInsured()) {
            return;
        }

        this.formulario = new InitFormModel(this.tipoPersona);
        this.found = false;
        this.initialInsuredBirthFound = false;
        this.naturalNotFound = false;
        this.setInsuredDocument();

        if (!this.requiresDataProcessing()) {
            this.bandera = 1;
            return;
        }

        this.customerLookupError = '';
        this.customerLookupInProgress = true;
        const requestId = ++this.customerLookupRequestId;
        if (this.dataProcessingStatus === 'PENDING') {
            this.saveInsuredAcceptance(requestId);
            return;
        }

        this.continueInsuredSearch(requestId);
    }

    private saveInsuredAcceptance(requestId: number): void {
        this.formService.postDataProcessingAcceptance(
            this.buildDataProcessingAcceptanceRequest(
                this.encryptedLookupDocument,
                this.getDataProcessingAcceptanceDocumentType(this.tipoDocumento)
            )
        )
            .subscribe(
                () => {
                    if (requestId !== this.customerLookupRequestId) {
                        return;
                    }

                    this.dataProcessingStatus = 'ACCEPTED';
                    this.continueInsuredSearch(requestId);
                },
                () => this.handleInsuredCustomerLookupError(requestId, 'No fue posible registrar la aceptación de uso de datos.')
            );
    }

    private continueInsuredSearch(requestId: number): void {
        if (requestId !== this.customerLookupRequestId) {
            return;
        }

        if (!this.requiresCustomerLookup()) {
            this.customerLookupInProgress = false;
            this.bandera = 1;
            return;
        }

        this.getInsuredCustomer(requestId);
    }

    private getInsuredCustomer(requestId: number): void {
        this.formService.postDataProcessingCustomer(this.buildDataProcessingCustomerRequest(this.encryptedLookupDocument)).subscribe(
            (response: any) => {
                if (requestId !== this.customerLookupRequestId) {
                    return;
                }

                this.customerLookupInProgress = false;
                this.handleInsuredCustomerResponse(response);
            },
            () => this.handleInsuredCustomerLookupError(requestId, 'No fue posible consultar los datos del cliente.')
        );
    }

    private handleInsuredCustomerLookupError(requestId: number, message: string): void {
        if (requestId !== this.customerLookupRequestId) {
            return;
        }

        this.customerLookupInProgress = false;
        this.customerLookupError = message;
    }

    private setInsuredDocument(): void {
        if (this.tipoPersona === 'J') {
            this.company.document.documentNumber = this.numeroDocumento;
            this.company.document.type = this.tipoDocumento;
            return;
        }

        this.person.document = {
            documentNumber: this.numeroDocumento,
            type: this.tipoDocumento,
        };
    }

    private buildDataProcessingAcceptanceRequest(
        encryptedDocument: string,
        documentType: string
    ): DataProcessingAcceptanceRequest {
        return {
            documentNumber: encryptedDocument,
            documentType,
            ramo: this.dataProcessingBranch,
            rucBroker: this.user.brokerId,
            email: this.user.email
        };
    }

    private buildDataProcessingCustomerRequest(encryptedDocument: string): DataProcessingCustomerRequest {
        return {
            documentNumber: encryptedDocument,
            documentType: '1',
            ramo: this.dataProcessingBranch,
            rucBroker: this.user.brokerId
        };
    }

    private handleInsuredCustomerResponse(response: any): void {
        if (!response || !response.firstName) {
            this.naturalNotFound = true;
            return;
        }

        if (this.cannotContinueWithCustomer(response)) {
            this.openDeceasedCustomerModal('INSURED');
            return;
        }

        const insuredPerson: InitPersonFormModel = {
            ...this.person,
            firstName: response.firstName,
            secondName: response.secondName,
            lastName: response.lastName,
            secondLastName: response.secondLastName,
            gender: response.gender,
            civilStatus: response.civilStatus,
        };
        if (response.birthDate) {
            insuredPerson.birthDate = new Date(response.birthDate);
            this.initialInsuredBirthFound = true;
        }

        this.person = insuredPerson;
        this.person.contacts.email.description = response.email;
        this.person.contacts.cellPhoneNumber.description = response.cellPhoneNumber;
        this.bandera = 1;
        this.found = true;
    }

    private cannotContinueWithCustomer(customer: any): boolean {
        const citizenCondition = String(customer.citizenCondition || '').trim().toUpperCase();
        const isDeceased = ['FALLECIDO', 'FALLECIDA'].indexOf(citizenCondition) !== -1;
        return Boolean(customer.deathDate) || isDeceased;
    }

    private openDeceasedCustomerModal(customerType: DeceasedCustomerType): void {
        this.deceasedCustomerType = customerType;
        this.deceasedCustomerModalOpen = true;
    }

    private clearInsuredSearch(): void {
        this.numeroDocumento = '';
        this.person = new InitPersonFormModel();
        this.company = new InitCompany();
        this.found = false;
        this.initialInsuredBirthFound = false;
        this.naturalNotFound = false;
        this.resetDataProcessingState();
    }

    changePersonType() {
        if (this.tipoPersona == "J") {
            this.company.document.documentNumber = this.numeroDocumento;
            this.company.document.type = this.tipoDocumento;
        } else {
            this.person.document = {
                documentNumber: this.numeroDocumento,
                type: this.tipoDocumento,
            };
        }
    }

    buscarContratante() {
        if (!this.canSearchContractor()) {
            return;
        }

        this.figura = new InitContratantePersona(this.tipoPersonaC);
        this.foundContract = false;
        this.initialContractBirthFound = false;
        this.figura.document.documentNumber = this.numeroDocumentoC;
        this.figura.document.type = this.tipoDocumentoC;

        if (!this.requiresContractorDataProcessing()) {
            this.mostrarContratante = true;
            this.botonEnviar = 0;
            return;
        }

        this.contractorCustomerLookupError = '';
        this.contractorLookupInProgress = true;
        const requestId = ++this.contractorLookupRequestId;
        if (this.contractorDataProcessingStatus === 'PENDING') {
            this.saveContractorAcceptance(requestId);
            return;
        }

        this.continueContractorSearch(requestId);
    }

    private saveContractorAcceptance(requestId: number): void {
        this.formService.postDataProcessingAcceptance(
            this.buildDataProcessingAcceptanceRequest(
                this.encryptedContractorLookupDocument,
                this.getDataProcessingAcceptanceDocumentType(this.tipoDocumentoC)
            )
        ).subscribe(
            () => {
                if (requestId !== this.contractorLookupRequestId) {
                    return;
                }

                this.contractorDataProcessingStatus = 'ACCEPTED';
                this.continueContractorSearch(requestId);
            },
            () => this.handleContractorCustomerLookupError(
                requestId,
                'No fue posible registrar la aceptación de uso de datos.'
            )
        );
    }

    private continueContractorSearch(requestId: number): void {
        if (requestId !== this.contractorLookupRequestId) {
            return;
        }

        if (!this.requiresContractorCustomerLookup()) {
            this.contractorLookupInProgress = false;
            this.mostrarContratante = true;
            this.botonEnviar = 0;
            return;
        }

        this.getContractorCustomer(requestId);
    }

    private getContractorCustomer(requestId: number): void {
        this.formService.postDataProcessingCustomer(
            this.buildDataProcessingCustomerRequest(this.encryptedContractorLookupDocument)
        ).subscribe(
            (response: any) => {
                if (requestId !== this.contractorLookupRequestId) {
                    return;
                }

                this.contractorLookupInProgress = false;
                this.handleContractorCustomerResponse(response);
            },
            () => this.handleContractorCustomerLookupError(requestId, 'No fue posible consultar los datos del contratante.')
        );
    }

    private handleContractorCustomerLookupError(requestId: number, message: string): void {
        if (requestId !== this.contractorLookupRequestId) {
            return;
        }

        this.contractorLookupInProgress = false;
        this.contractorCustomerLookupError = message;
    }

    private handleContractorCustomerResponse(response: any): void {
        if (!response || !response.firstName) {
            this.naturalNotFound = true;
            return;
        }

        if (this.cannotContinueWithCustomer(response)) {
            this.openDeceasedCustomerModal('CONTRACTOR');
            return;
        }

        const contractor = {
            ...this.figura,
            firstName: response.firstName,
            secondName: response.secondName,
            lastName: response.lastName,
            secondLastName: response.secondLastName,
            gender: response.gender,
            civilStatus: response.civilStatus,
            personType: this.tipoPersonaC,
        };
        if (response.birthDate) {
            contractor.birthDate = new Date(response.birthDate);
            this.initialContractBirthFound = true;
        }

        this.mostrarContratante = true;
        this.naturalNotFound = false;
        this.figura = contractor;
        this.botonEnviar = 0;
        this.figura.contacts.email.description = response.email;
        this.figura.contacts.cellPhoneNumber.description = response.cellPhoneNumber;
        this.foundContract = true;
    }

    private clearContractorSearch(): void {
        this.numeroDocumentoC = '';
        this.figura = null;
        this.foundContract = false;
        this.initialContractBirthFound = false;
        this.mostrarContratante = false;
        this.botonEnviar = 1;
        this.naturalNotFound = false;
        this.resetContractorDataProcessingState();
    }

    enviar() {
        if (this.botonEnviar == 0) {
            this.armar();
            this.formService.postClient(this.nuevoFormulario).subscribe(
                (resp: any) => {
                    let idCode;
                    if (resp.code) {
                        idCode = resp.code;
                    } else {
                        idCode = 0;
                    }

                    this.router.navigate(["/solicitudesFin/", idCode]);
                },
                (err: any) => console.log(err),
                () => { }
            );
        }
        if (this.botonEnviar == 1) {
            this.buscarContratante();
        }
    }

    esContratante(asegurado) {
        // console.log(asegurado)
        if (asegurado == true) {
            this.resetContractorDataProcessingState();
            this.botonEnviar = 0;
        } else {
            this.resetContractorDataProcessingState();
            this.botonEnviar = 1;
        }
    }

    armar() {
        this.nuevoFormulario = this.formulario;
        this.nuevoFormulario.data.personType = this.tipoPersona;
        if (this.tipoPersona == "N") {
            if (this.person.civilStatus.id == 1) {
                this.person.civilStatus.description = "Soltero";
            }
            if (this.person.civilStatus.id == 2) {
                this.person.civilStatus.description = "Casado";
            }
            if (this.person.civilStatus.id == 3) {
                this.person.civilStatus.description = "Unión Libre";
            }
            if (this.person.civilStatus.id == 4) {
                this.person.civilStatus.description = "Divorciado";
            }
            if (this.person.civilStatus.id == 5) {
                this.person.civilStatus.description = "Viudo";
            }
            this.nuevoFormulario.data.person = this.person;
        } else {
            this.nuevoFormulario.data.company = this.company;
        }
        this.nuevoFormulario.data.broker.id = this.user.brokerId;
        this.nuevoFormulario.data.broker.document.documentNumber =
            this.user.brokerId;
        this.nuevoFormulario.data.broker.businessName = this.user.brokerName;
        this.nuevoFormulario.data.broker.contacts.email.description =
            this.user.email;
        if (!this.haveContracting) {
            this.nuevoFormulario.data.figures = [];

            this.nuevoFormulario.data.isContractingBeneficiaryInsured = false;
            let figureToSave: InitContratantePersona = {
                contacts: this.figura.contacts,
                document: this.figura.document,
                personType: this.tipoPersonaC,
                type: "CONTRACTOR",
            };
            if (this.tipoPersonaC == "N") {
                figureToSave = {
                    ...figureToSave,
                    firstName: this.figura.firstName,
                    lastName: this.figura.lastName,
                    secondName: this.figura.secondName,
                    secondLastName: this.figura.secondLastName,
                    civilStatus: this.figura.civilStatus,
                    birthDate: this.figura.birthDate,
                    gender: this.figura.gender,
                };
            } else {
                figureToSave = {
                    ...figureToSave,
                    businessName: this.figura.businessName,
                    constitutionDate: this.figura.constitutionDate,
                };
            }
            this.nuevoFormulario.data.figures[0] = figureToSave;
        }
    }

    volver() {
        this.resetDataProcessingState();
        this.bandera = 0;
        this.botonEnviar = 0;
        this.mostrarContratante = false;
        this.figura = null;
        this.haveContracting = true;
        this.personC = new PersonFormModel();
        this.aseguradoC = null;
        this.companyC = new InitCompany();
        this.formulario = new InitFormModel();
        this.nuevoFormulario = null;
        this.person = new PersonFormModel();
        this.company = new InitCompany();
        this.tipoDocumentoC = null;
        this.numeroDocumentoC = null;
        this.tipoPersona = "N";
        this.tipoPersonaC = "N";
    }
}
